import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const Config = {
    'User': {
        title: '临床报价评估人员',
        url: API_URL.evaluate.updateEvaluateUserId,
        queryType: 'queryEvaluateUser',
    },
    'BD': {
        title: 'BD',
        url: API_URL.evaluate.assignBdBa,
        roleCodes: 'BD,BDO',
    },
    'BA': {
        title: 'BA',
        url: API_URL.evaluate.assignBdBa,
        roleCodes: 'BA,BAL',
    },
}

class AssignUser extends Component {
    state = {
        params: {},
        type: 'User',
        visible: false,
        loading: false,
    }

    show = (record, type) => {
        const { evaluateRecordId, pmName, pmCode, baName, baCode, bdName, bdCode, evaluateUserId } = record;
        let configName = '';
        switch (type) {
            case 'User':
                configName = (pmName && pmCode) ? `${pmName}[${pmCode}]` : undefined;
                break;
            case 'BD':
                configName = (bdName && bdCode) ? `${bdName}[${bdCode}]` : undefined;
                break;
            case 'BA':
                configName = (baName && baCode) ? `${baName}[${baCode}]` : undefined;
                break;
        }
        this.setState({
            params: {
                evaluateRecordId,
                userId: evaluateUserId,
                userName: configName,
            },
            visible: true,
            type,
        });
    }

    hide = () => {
        this.setState({ 
            params: {},
            visible: false,
            loading: false,
        });
    }

    submit = () => {
        const { params, type } = this.state;
        const { userId, evaluateRecordId } = params;
        if (!userId) {
            message.warning(`请选择${Config[type].title}`);
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: Config[type].url,
            data: {
                evaluateRecordId,
                evaluateUserId: userId,
                userId,
                type,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (option) => {
        const { params } = this.state;
        const { value, text } = option || {};
        params.userId = value;
        params.userName = text;
        this.setState({ params });
    }

    render() {
        const { visible, loading, params, type } = this.state;
        const { userName } = params;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title={`配置${Config[type].title}`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                confirmLoading={loading}
                className="create-modal EditPersonModal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width={450}
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                <div className="item-left">{asterisk}{`${Config[type].title} :`}</div>
                                <div className="item-right">
                                    <SearchRetrieve
                                        keyword='keyWord'
                                        style={{ width: 162 }}
                                        placeholder="输入姓名/工号检索"
                                        value={userName}
                                        params={{ limit: 20, queryType: Config[type].queryType, roleCodes: Config[type].roleCodes }}
                                        url={API_URL.teaching.queryEmpListByRoleCode}
                                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default AssignUser;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/AssignUser.js